define.alias("shared/components/shared/social/refresh-profile/facebook", "settings/components/shared/social/refresh-profile/facebook");